import React from 'react'
import './card.css'

export default function Card({ id, onClick, isExpandable, className, status, children, size, fullWidth, style }) {
    // NOTE: The size prop here is only intended for use with expander cards, to allow for max-height flexibility between cards with one or more rows of info above
    // the expander button

    return (
        <div id={ id ? id : '' }
            className={ `card ${ status ? 'card--' + status.replace(/\s+/g, '-').toLowerCase() : '' } ${ isExpandable ? 'card-expandable' : '' } ${ size && isExpandable ? `card-expandable-${ size }` : '' } ${ fullWidth ? 'card-fullWidth' : '' } ${className || ''}` }
            onClick={ (e) => {
                if (onClick) { onClick(e) }
            }}
            style={ style }
        >
            { children }
        </div>
    )
}